import { AfterViewChecked, Component, ChangeDetectionStrategy, Input, ElementRef, input, output, viewChild } from '@angular/core';
import { IconComponent } from '@teamfoster/sdk/icon';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, FormsModule, NgClass, FromDictionaryPipe],
})
export class SearchFieldComponent implements AfterViewChecked {
  readonly type = input<string>();
  @Input() set value(val: string | undefined) {
    this.search = val ?? '';
  }
  readonly placeholder = input<string>();
  readonly focus = input<boolean>();

  readonly searchInput = output<string>();
  readonly focused = output<boolean>();

  readonly searchField = viewChild<ElementRef>('searchField');

  search = '';

  hasFocused = false;

  ngAfterViewChecked(): void {
    if (this.focus() && !this.hasFocused) {
      this.searchField()?.nativeElement.focus();
      this.hasFocused = true;
    }
  }
}
